import React, { useState } from "react";
import { NavLink, useHistory } from "react-router-dom";
import { Formik } from "formik";
import tw from "twin.macro";
import styled from "styled-components";
import {css} from "styled-components/macro"; //eslint-disable-line
import { getAuth, signOut } from "firebase/auth";

import logo from "images/images/smiles_and_laughters_logo2.png";

import { getUser, HandlesignInWithEmail, HandleResetPassword, HandleSignInWithGoogle } from "services/FirebaseAuthService";

import { APP_NAME } from "../constants";

import {
  minMaxLength,
  validEmail,
  passwordStrength,
} from "services/Validation";

import cogoToast from "cogo-toast";
import { fetchUsers } from "DBServices/firestoreDBService";


import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import { Container as ContainerBase } from "components/misc/Layouts";
import illustration from "images/images/gettyimages-635967776-612x612.jpg";
//import logo from "images/logo.svg";
import googleIconImageSrc from "images/google-icon.png";
import { ReactComponent as LoginIcon } from "feather-icons/dist/icons/log-in.svg";
import Navbar from "components/Navbar";

const Container = styled(ContainerBase)`
  ${tw`min-h-screen text-white font-medium flex justify-center mt-0`}
  background: linear-gradient(135deg, #022c22 0%, #115e59 100%);
`;
const Content = tw.div`max-w-screen-xl m-0 sm:mx-20 sm:my-16 bg-white text-gray-900 shadow sm:rounded-2xl flex justify-center flex-1 overflow-hidden`;
const MainContainer = tw.div`lg:w-1/2 xl:w-5/12 p-6 sm:p-12 flex flex-col justify-center`;
const LogoLink = tw.a`flex justify-center mb-4`;
const LogoImage = tw.img`h-12 mx-auto`;
const MainContent = tw.div`mt-4 flex flex-col items-center`;
const Heading = tw.h1`text-2xl xl:text-3xl font-extrabold text-gray-800`;
const FormContainer = tw.div`w-full flex-1 mt-6`;

const SocialButtonsContainer = tw.div`flex flex-col items-center`;
const SocialButton = styled.a`
  ${tw`w-full max-w-xs font-semibold rounded-xl py-3 border text-gray-700 bg-white flex items-center justify-center transition-all duration-200 focus:outline-none focus:shadow-outline text-sm mt-4 first:mt-0 shadow-sm`}
  border: 1px solid #e2e8f0;
  &:hover {
    background-color: #f7fafc;
    border-color: #cbd5e0;
  }
  .iconContainer {
    ${tw`bg-white p-2 rounded-full`}
  }
  .icon {
    ${tw`w-4`}
  }
  .text {
    ${tw`ml-4`}
  }
`;

const DividerTextContainer = tw.div`my-8 border-b border-gray-200 text-center relative`;
const DividerText = tw.div`leading-none px-4 inline-block text-sm text-gray-500 tracking-wide font-medium bg-white transform -translate-y-1/2 absolute left-1/2 -translate-x-1/2`;

const Form = tw.form`mx-auto max-w-xs`;
const Input = tw.input`w-full px-5 py-4 rounded-xl font-medium bg-gray-100 border border-gray-200 placeholder-gray-500 text-sm focus:outline-none focus:border-green-600 focus:bg-white transition duration-200 mt-4 first:mt-0`;
const SubmitButton = styled.button`
  ${tw`mt-6 tracking-wide font-bold text-white w-full py-4 rounded-xl shadow-md hover:shadow-lg transition-all duration-300 ease-in-out flex items-center justify-center focus:shadow-outline focus:outline-none transform hover:-translate-y-1`}
  background: linear-gradient(135deg, #059669 0%, #047857 100%);
  .icon {
    ${tw`w-5 h-5 -ml-2`}
  }
  .text {
    ${tw`ml-3`}
  }
`;
const IllustrationContainer = tw.div`sm:rounded-r-lg flex-1 bg-gray-100 text-center hidden lg:flex justify-center items-center`;
const IllustrationImage = styled.div`
  ${props => `background-image: url("${props.imageSrc}");`}
  ${tw`m-12 xl:m-16 w-full max-w-sm h-96 bg-cover bg-center bg-no-repeat rounded-2xl shadow-md`}
`;

export default ({
  logoLinkUrl = "#",
  illustrationImageSrc = illustration,
  headingText = `Sign In To ${APP_NAME}`,
  socialButtons = [
    {
      iconImageSrc: googleIconImageSrc,
      text: "Sign In With Google",
      url: "#",
      action: "google"
    }
  ],
  submitButtonText = "Sign In",
  SubmitButtonIcon = LoginIcon,
  forgotPasswordUrl = "#",
  signupUrl = "/signup",

}) => {

  const [isLogin, setIsLogin] = useState(false)
  const [isSubmittingAfter, setIsSubmittingAfter ] = useState(false)
  
  const history = useHistory()
  const auth = getAuth();

  console.log("Login Page - Auth instance:", auth);
  console.log("Login Page - Current user:", auth.currentUser);
  console.log("Login Page - isLogin state:", isLogin);
  console.log("Login Page - Should show form:", !isLogin);

  const handleLogout = async () => {
    console.log("Logout clicked");
    setIsSubmittingAfter(true);
    try {
      await signOut(auth);
      console.log("Logout successful");
      setIsLogin(false);
      history.push('/');
    } catch (error) {
      console.error("Logout error:", error);
    } finally {
      setIsSubmittingAfter(false);
    }
  };
  
  React.useEffect(() => {
    console.log("Login useEffect running");
    let isMounted = true;
    
    const user = getUser.auth.currentUser;
    console.log("Login - User from getUser:", user);

    if (user && isMounted) {
      console.log("User is logged in, setting isLogin to true");
      setIsLogin(true)
    } else {
      console.log("No user logged in");
    }
    
    return () => {
      console.log("Login component unmounting");
      isMounted = false;
    }
  }, []);

  const resetPassword = (e) => {
    e.preventDefault();
    const email = window.prompt("Please enter your email here to reset your password");
    if (!email) return;
    HandleResetPassword.sendPasswordResetEmail(HandleResetPassword.auth, email)
      .then(() => {
        cogoToast.success(`Password reset email sent! Check email to continue.`);
      })
      .catch((error) => {
        cogoToast.error(`${error.message.replace('Firebase: ', '')}`);
      });
  }
  return (
  <AnimationRevealPage>
    <Navbar />
    <Container>
      <Content>
        <MainContainer>
          <LogoLink href={logoLinkUrl}>
            <LogoImage src={logo} />
          </LogoLink>
          <MainContent>
            <Heading>{headingText}</Heading>
            {!isLogin ? <FormContainer>
              <SocialButtonsContainer>
                {socialButtons.map((socialButton, index) => (
                  <SocialButton 
                    key={index} 
                    href={socialButton.url}
                    onClick={async (e) => {
                      e.preventDefault();
                      if (socialButton.action === "google") {
                        try {
                          const result = await HandleSignInWithGoogle();
                          const user = result.user;
                          cogoToast.info("Verifying user profile...");
                          const allUsers = await fetchUsers();
                          const existingUser = allUsers.find(u => u.uid === user.uid || u.Email === user.email);
                          
                          if (existingUser) {
                            cogoToast.success("Successfully logged in!");
                            setIsLogin(true);
                            if (existingUser.accountType === "partner") {
                              history.push("/partner");
                            } else {
                              history.push("/");
                            }
                          } else {
                            cogoToast.warn("Profile incomplete. Redirecting to onboarding...");
                            history.push("/complete-profile");
                          }
                        } catch (error) {
                          console.error("Google sign in error:", error);
                          cogoToast.error(error.message || "Failed to sign in with Google.");
                        }
                      }
                    }}
                  >
                    <span className="iconContainer">
                      <img src={socialButton.iconImageSrc} className="icon" alt=""/>
                    </span>
                    <span className="text">{socialButton.text}</span>
                  </SocialButton>
                ))}
              </SocialButtonsContainer>
              <DividerTextContainer>
                <DividerText>Or Sign in with your e-mail</DividerText>
              </DividerTextContainer>
              <Formik
                initialValues={{ email: "", password: "", message: "" }}
                validate={(values) => {
                  const errors = {};

                  if (!values.email || validEmail(values.email)) {
                    errors.email =
                      "It seems the email address you entered is invalid";
                  } else {
                    delete errors.email;
                  }

                  if (minMaxLength(values.password, 6)) {
                    errors.password =
                      "Password should have minimum 6 characters";
                  } else if (passwordStrength(values.password)) {
                    errors.password =
                      "Password is not strong enough. Include an upper case letter, a number or a special character to make it strong";
                  } else {
                    delete errors.password;
                  }

                  return errors;
                }}
                onSubmit={async (values, { setSubmitting }) => {
                  console.log("Login form submitted with values:", { email: values.email, password: "***" });
                  setSubmitting(true);
                  
                  try {
                    console.log("Attempting to sign in...");
                    const userCredential = await HandlesignInWithEmail(values);
                    console.log("Sign in successful! User credential:", userCredential);
                    
                    const user = userCredential.user;
                    console.log("User object:", {
                      uid: user.uid,
                      email: user.email,
                      displayName: user.displayName
                    });
                    
                    if (user) {
                      console.log("Redirecting to home page...");
                      history.push("/")
                    }
                  } catch (error) {
                    console.error("Login error:", error);
                    console.error("Error code:", error.code);
                    console.error("Error message:", error.message);
                    
                    const resMessage =
                          (error.code &&
                            error.message) ||
                          error.message ||
                          error.toString();
                    values.message = resMessage.replace("Firebase: ", '');
                    console.log("Setting error message:", values.message);
                    return setSubmitting(false);
                  }
                }}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting,
                  /* and other goodies */
                }) => (
              <Form onSubmit={handleSubmit}>
                <Input type="email" 
                        name="email"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.email}
                        placeholder="Email" />
                        {errors.email && touched.email && errors.email}
                <Input type="password" placeholder="Password"
                name="password"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.password}
              />
              {errors.password && touched.password && errors.password}
                <SubmitButton type="submit">
                  <SubmitButtonIcon className="icon" disabled={isSubmitting} />
                  {isSubmitting && (
                        <span className="spinner-border spinner-border-sm"></span>
                      )}
                  <span className="text">{submitButtonText}</span>
                </SubmitButton>

                    {values.message && (
                      <div className="form-group">
                        <div className="alert alert-danger" role="alert">
                          {values.message}
                        </div>
                      </div>
                    )}
              </Form>
              )}
              </Formik>
              <p tw="mt-6 text-xs text-gray-600 text-center">
                <a href="#" onClick={resetPassword} tw="border-b border-gray-500 border-dotted">
                  Forgot Password ?
                </a>
              </p>
              <p tw="mt-8 text-sm text-gray-600 text-center">
                Dont have an account?{" "}
                <a href={signupUrl} 
                   tw="border-b border-gray-500 border-dotted">
                  Sign Up
                </a>
              </p>
              
            </FormContainer> 
            : 
            <div>
              <SubmitButton onClick={() => {
                setIsSubmittingAfter(true)
                history.push('/')}}>
                <SubmitButtonIcon className="icon" />
                {isSubmittingAfter && (
                  <span className="spinner-border spinner-border-sm"></span>
                )}
                <span className="text">Continue to Home</span>
              </SubmitButton>
              <SubmitButton onClick={handleLogout} tw="mt-4 bg-red-500 hover:bg-red-700">
                <SubmitButtonIcon className="icon" />
                {isSubmittingAfter && (
                  <span className="spinner-border spinner-border-sm"></span>
                )}
                <span className="text">Logout</span>
              </SubmitButton>
            </div>
            }
          </MainContent>
        </MainContainer>
        <IllustrationContainer>
          <IllustrationImage imageSrc={illustrationImageSrc} />
        </IllustrationContainer>
      </Content>
    </Container>
  </AnimationRevealPage>
)
}
